import {Action} from "@ngrx/store";
import {NodeDependencies} from "@ispm/shared/bpmn/models/node-dependencies";

export enum NodesDependenciesActionTypes {
  UPDATE_NODES_DEPENDENCIES = '[Bpmn Process] Update Nodes Dependencies'
}

export class UpdateNodesDependenciesAction implements Action {
  readonly type = NodesDependenciesActionTypes.UPDATE_NODES_DEPENDENCIES;
  constructor(public payload: { nodeSelectionDependencies: NodeDependencies }){ }
}

export type NodesDependenciesActions =
  UpdateNodesDependenciesAction;
